module.exports = __webpack_public_path__ + "static/media/poppins-v15-latin-regular.78430a28.eot";